import {Designer, Tag} from '@brg/api';
import { TLangObject } from '@brg/api/dist/api-core/types/Generic'

    // @ts-ignore
export const convertDesignerFromGlobalToLocal = (designer: Designer<'Global'>, lang: string): Designer<'Local'> => ({
  ...designer,
  about: tLangObjectToString(designer.about, lang),
  name: tLangObjectToString(designer.name, lang),
  surName: tLangObjectToString(designer.surName, lang),
  middleName: tLangObjectToString(designer.middleName, lang),
  nameCache: tLangObjectToString(designer.nameCache, lang),
  socialNetworks: designer.socialNetworks.map((network) => ({
    ...network,
    name: tLangObjectToString(network.name, lang),
  })),
  workPlaces: designer.workPlaces.map((place) => ({
    ...place,
    team: tLangObjectToString(place.team, lang),
  })),
  education: designer.workPlaces.map((place) => ({
    ...place,
    team: tLangObjectToString(place.team, lang),
  })),
});

export const tLangObjectToString = (tLang: TLangObject<'Global' | 'Local'>, lang: string): string => {
  if (typeof tLang === 'string') {
    return tLang;
  }

  let value = '';
  let notEmptyValue = '';

  if (Array.isArray(tLang)) {
    lang = lang.toLowerCase();

    tLang.forEach((tLang) => {
      if (tLang.lang.toLowerCase() === lang) {
        value = tLang.name;
      }

      if (!notEmptyValue && tLang.name) {
        notEmptyValue = tLang.name;
      }
    });
  }

  return value || notEmptyValue;
};

export const extractNameFromDesigner = (
  designer: Designer<'Global' | 'Local'>,
  fieldName: 'name' | 'surName' | 'about' | 'nameCache',
  lang: string
): string => {
  if (typeof designer[fieldName] === 'string') {
    return designer[fieldName] as string;
  }

  let value = '';
  let notEmptyValue = '';

  if (Array.isArray(designer[fieldName])) {
    lang = lang.toLowerCase();

    (designer as Designer<'Global'>)[fieldName].forEach((tLang) => {
      if (tLang.lang.toLowerCase() === lang) {
        value = tLang.name;
      } else if (!notEmptyValue && tLang.name) {
        notEmptyValue = tLang.name;
      }
    });
  }

  return value || notEmptyValue;
};

export const convertTagFromGlobalToLocal = (tag: Tag<'Global'>, lang: string): Tag<'Local'> => ({
  ...tag,
  name: tLangObjectToString(tag.name, lang),
  description: tLangObjectToString(tag.description, lang),
});

export const convertTagFromGlobalToLocalEdit = (tag: Tag<'Global'>): Tag<'Local'> => ({
  ...tag,
  name: tLangObjectToString(tag.name, "en") + " | " + tLangObjectToString(tag.name, "ru"),
  description: tLangObjectToString(tag.description, "en"),
});import {Designer, Tag} from '@brg/api';
import { TLangObject } from '@brg/api/dist/api-core/types/Generic'

    // @ts-ignore
export const convertDesignerFromGlobalToLocal = (designer: Designer<'Global'>, lang: string): Designer<'Local'> => ({
  ...designer,
  about: tLangObjectToString(designer.about, lang),
  name: tLangObjectToString(designer.name, lang),
  surName: tLangObjectToString(designer.surName, lang),
  middleName: tLangObjectToString(designer.middleName, lang),
  nameCache: tLangObjectToString(designer.nameCache, lang),
  socialNetworks: designer.socialNetworks.map((network) => ({
    ...network,
    name: tLangObjectToString(network.name, lang),
  })),
  workPlaces: designer.workPlaces.map((place) => ({
    ...place,
    team: tLangObjectToString(place.team, lang),
  })),
  education: designer.workPlaces.map((place) => ({
    ...place,
    team: tLangObjectToString(place.team, lang),
  })),
});

export const tLangObjectToString = (tLang: TLangObject<'Global' | 'Local'>, lang: string): string => {
  if (typeof tLang === 'string') {
    return tLang;
  }

  let value = '';
  let notEmptyValue = '';

  if (Array.isArray(tLang)) {
    lang = lang.toLowerCase();

    tLang.forEach((tLang) => {
      if (tLang.lang.toLowerCase() === lang) {
        value = tLang.name;
      }

      if (!notEmptyValue && tLang.name) {
        notEmptyValue = tLang.name;
      }
    });
  }

  return value || notEmptyValue;
};

export const extractNameFromDesigner = (
  designer: Designer<'Global' | 'Local'>,
  fieldName: 'name' | 'surName' | 'about' | 'nameCache',
  lang: string
): string => {
  if (typeof designer[fieldName] === 'string') {
    return designer[fieldName] as string;
  }

  let value = '';
  let notEmptyValue = '';

  if (Array.isArray(designer[fieldName])) {
    lang = lang.toLowerCase();

    (designer as Designer<'Global'>)[fieldName].forEach((tLang) => {
      if (tLang.lang.toLowerCase() === lang) {
        value = tLang.name;
      } else if (!notEmptyValue && tLang.name) {
        notEmptyValue = tLang.name;
      }
    });
  }

  return value || notEmptyValue;
};

export const convertTagFromGlobalToLocal = (tag: Tag<'Global'>, lang: string): Tag<'Local'> => ({
  ...tag,
  name: tLangObjectToString(tag.name, lang),
  description: tLangObjectToString(tag.description, lang),
});

export const convertTagFromGlobalToLocalEdit = (tag: Tag<'Global'>): Tag<'Local'> => ({
  ...tag,
  name: tLangObjectToString(tag.name, "en") + " | " + tLangObjectToString(tag.name, "ru"),
  description: tLangObjectToString(tag.description, "en"),
});